var React = require('react');

function Aircraft (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"aircraft"),React.createElement("path",{"d":"M12.496 17.414c-0.394-1.096-1.805-4.775-2.39-6.297-1.103 0.737-2.334 1.435-3.512 1.928-0.366 1.28-1.094 3.709-1.446 4.033-0.604 0.557-0.832 0.485-0.925-0.279s-0.485-3.236-0.485-3.236-2.162-1.219-2.84-1.568-0.667-0.591 0.057-0.974c0.422-0.223 2.927-0.085 4.242 0.005 0.861-0.951 1.931-1.882 2.993-2.679-1.215-1.076-4.15-3.675-5.034-4.424-0.776-0.658 0.079-0.797 0.079-0.797 0.39-0.070 1.222-0.132 1.628-0.009 2.524 0.763 6.442 2.068 7.363 2.376 0.353-0.249 0.737-0.52 1.162-0.821 4.702-3.33 5.887-2.593 6.111-2.27s0.503 1.701-4.199 5.032c-0.425 0.301-0.808 0.573-1.16 0.823-0.029 0.98-0.157 5.151-0.311 7.811-0.025 0.428-0.367 1.198-0.565 1.544-0.001 0-0.423 0.765-0.768-0.198z","key":1})]);
}

Aircraft.defaultProps = {"version":"1.1","width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = Aircraft;

Aircraft.default = Aircraft;
